import logo from './logo.svg';
import './App.scss';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import Login from './Pages/Login/Login';
import PrivateRoutes from './Auth/PrivateRoutes';
import AdminConsole from './Pages/AdminConsole/AdminConsole';
import UserGraph from './Pages/UserGraph/UserGraph';

function App() {
  return (
      <Router>
        <Routes>
            {/* Public routes */}
            <Route path='/' element={<Login />}/>
            <Route path='/login' element={<Login />}/>
            <Route path='/graph/:id' element={<UserGraph />} />
            {/* Protected routes */}
            <Route element={<PrivateRoutes/>} >
                <Route path='/admin' element={<AdminConsole/>} />
            </Route>
        </Routes>
    </Router>
  );
}

export default App;
